import RouteNames from '../../../../../../app/router/_internals/RouteNames.enum';

export default Object.freeze({
	GENERAL: `${RouteNames.DEVICES}-general`,
	PHONE_INFO: `${RouteNames.DEVICES}-phone-info`,
	PERMISSIONS: `${RouteNames.DEVICES}-permissions`,
	HOTDESKING: `${RouteNames.DEVICES}-hotdesking`,
	HISTORY: `${RouteNames.DEVICES}-history`,
});
